<template>
  <b-row>
    <b-col sm="12" class="mb-3">
      <h5 class="package-name-background p-2"><strong>{{ tour.name }} / {{ date.date }}</strong></h5>
      <b-row>
        <b-col sm="4">
          <h6 class="package-title font-weight-bold border-bottom pb-1 text-primary" v-translate>Price details</h6>
          <b-table-simple responsive small bordered>
            <b-tbody>
              <b-tr>
                <b-th class="package-name-background" v-translate>Total client</b-th>
                <b-td>{{ date.price.gross + date.price.tax }} {{ tour.currency }}</b-td>
              </b-tr>
              <b-tr>
                <b-th class="package-name-background" v-translate>Taxes</b-th>
                <b-td>{{ date.price.tax }} {{ tour.currency }}</b-td>
              </b-tr>
              <b-tr>
                <b-th class="package-name-background" v-translate> Commision</b-th>
                <b-td>{{ date.price.commission }} {{ tour.currency }}</b-td>
              </b-tr>
              <b-tr>
                <b-th class="package-name-background" v-translate>Total payment</b-th>
                <b-td>{{ date.price.gross + date.price.tax - date.price.commission }} {{ tour.currency }}</b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </b-col>
        <b-col sm="4">
          <h6 class="package-title pb-1 font-weight-bold border-bottom text-primary" v-translate>Discounts applied</h6>
          <div v-for="(discount, discountIndex) in date.discounts"  :key="'discount' + discountIndex">
            <h6 class="package-title">{{ discount.label }}</h6>
            <p class="mb-1" v-if="discount.description">{{ discount.description }}</p>
            <p class="mb-1">
              <b v-translate>Offer validity: </b>&nbsp;
              <span v-if="!discount.bookingFrom && !discount.bookingTo"><translate>any</translate></span><br/>
              <span v-if="discount.bookingFrom && !discount.bookingTo" class="d-block mb-1"><translate>from</translate> {{ formatDate(discount.bookingFrom) }}</span>
              <span v-if="!discount.bookingFrom && discount.bookingTo" class="d-block mb-1"><translate>until</translate> {{ formatDate(discount.bookingTo) }}</span>
              <span v-if="discount.bookingFrom && discount.bookingTo"><translate>between</translate> {{ formatDate(discount.bookingFrom) }}
                <translate>and</translate> {{ formatDate(discount.bookingTo) }}</span>
            </p>
            <p class="mb-1">
            <b v-translate>Travel dates:</b>
              <span v-if="discount.all_dates">&nbsp;<translate>any departure date</translate></span>
              <span v-else>&nbsp;
                <span v-for="(discountDate, dIndex) in discount.dates" :key="`d-${dIndex}`">
                  {{ formatDate(discountDate) }}
                </span>
              </span>
            </p>
            <p class="m-0" v-translate v-if="!date.discounts.length">No discounts were applied</p>
          </div>
        </b-col>
        <b-col sm="4">
          <b-card class="bg-light" no-body v-if="paymentSchedule">
            <b-card-header class="d-flex justify-content-between">
              <b v-translate>Payments schedule </b> <b class="text-primary">{{ tour.currency }}</b>
            </b-card-header>
            <b-list-group flush>
              <b-list-group-item v-for="(dd, ddIndex) in paymentSchedule" :key="'dd' + ddIndex">
                {{ formatDate(dd.date) }} - <b>{{ ceil(dd.amount) || $gettext('balance') }} </b>
              </b-list-group-item>
            </b-list-group>
          </b-card>
        </b-col>
        <b-col sm="12">
          <cancelCond />
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import moment from 'moment'
import { paymentSchedule } from 'b2b-common/services/api/tour'
import cancelCond from '@/app/private/shared/components/cancel_cond.vue'

export default {
  name: 'PriceDetails',
  components: {
    cancelCond
  },
  props: {
    tour: {
      type: Object,
      required: true
    },
    date: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      paymentSchedule: null
    }
  },
  async mounted () {
    this.paymentSchedule = await paymentSchedule({ tour: this.tour.id, date: this.date.date })
  },
  methods: {
    formatDate (d) {
      return moment(d, 'YYYY-MM-DD').format('DD/MM/YYYY')
    },
    ceil (no) {
      return Math.ceil(no)
    }
  }
}
</script>
